.studiestedWrapper {
  position: relative;

  .valueHoverCard {
    position: absolute;
    top: 2.65em;
    right: 3.25em;
  }
}
